import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import SearchBar from "../../../../Components/Utils/SearchBar";
import {
  BackButton,
  CancelButton,
  ClearFilterButton,
  CreateButton,
  EditButton,
  ExportButton,
  FilterButton,
  ImportButton,
  SubmitButton,
} from "../../../../Components/Utils/Buttons";
import { GetAccess } from "../../../../Components/Utils/roles";
import Breadcrumb from "../../../../Components/Utils/Breadcrumb";
import {
  NuDataTime,
  NuInput,
  NuTextArea,
} from "../../../../Components/Utils/Input";
import DropDownAddMetaData from "../../../../Components/Utils/selectAddMetaData";
import { useFormik } from "formik";
import useAddFormData from "../../../../Components/Hooks/useAddFormData";
import useFetchMataData from "../../../../Components/Hooks/useFetchMataData";
import CloseIcon from "../../../../Components/Icons/Close";
import * as yup from "yup";
import axiosInstance from "../../../../Services/axiosCommon";
import NuAmount from "../../../../Components/Utils/NuAmount";

const OutgoingLayout = ({
  getData = () => { },
  setSearchQuery = () => { },
  CreateAccess = false,
  ImportAccess = false,
  BackAccess = false,
  EditAccess = false,
  PayAccess = false,
  setOpen = () => { },
  setOpenExport = () => { },
  children,
  onCreateClick,
  searchValue = "",
  searchFun = () => { },
  isFilter = false,
  setFilterOpen = () => { },
  newfilter = false,
  ClearFilter = () => { },
  neededSearch = false,
  showproject = true,
  isCard = true,
  setViewMode = () => { },
  viewMode = "",
  ExportAccess = false,
  totalLength = 0,
  balAmount = 0,
  totalAmount = 0,
  paidAmount = 0,
  isPaymentHistory = false,
}) => {
  let { pathname } = useLocation();
  const [module, setModule] = useState("");

  const [showCreate, setShowCreate] = useState(false);

  const navigate = useNavigate();
  const { invoiceOutgoingViewId } = useParams();

  const location = useLocation();

  //   const data = location.state?.data;
  const pageIndex = location.state?.pageIndex;
  const searchQuery = location.state?.searchQuery;
  const [data, setData] = useState(location.state?.data || []);
  const paymentsHistory = data?.paymentsHistory;
  const fromDashboard = location.state?.fromDashboard === true;

  let searchList = [
    { value: "all", label: "All" },
    { value: "services", label: "Services" },
    { value: "products", label: "Products" },
  ];

  const [screenSize, setScreenSize] = useState({
    width: window.innerWidth,
  });

  useEffect(() => {
    const handleResize = () => {
      setScreenSize({
        width: window.innerWidth,
      });
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    if (pathname == `/invoice/invoice-outgoing/view/${invoiceOutgoingViewId}`) {
      setModule("Details");
    } else if (
      pathname ==
      `/invoice/invoice-outgoing/payment-history/${invoiceOutgoingViewId}`
    ) {
      setModule("Payment History");
    }
  }, [pathname]);

  let LinkItem = [
    {
      label: "Details",
      link: `/invoice/invoice-outgoing/view/${invoiceOutgoingViewId}`,
      access: GetAccess(),
    },
    {
      label: "Payment History",

      link: `/invoice/invoice-outgoing/payment-history/${invoiceOutgoingViewId}`,
      access: GetAccess(),
    },
  ];

  const [tab, setTab] = useState();

  function getView() {
    axiosInstance
      .get(`/invoices-outgoing/${invoiceOutgoingViewId}`)
      .then((res) => {
        setTab(res.data?.data?.paymentsHistory);
      })
      .catch((err) => {
        console.log("err", err);
      });
  }

  useEffect(() => {
    // if (!cData) {
    getView();
    // }
  }, []);

  const AllTabs = [
    {
      label: "Details",
      link: `/invoice/invoice-outgoing/view/${invoiceOutgoingViewId}`,
      access: "invoice_view",
    },
    {
      label: "Payment History",
      link: `/invoice/invoice-outgoing/payment-history/${invoiceOutgoingViewId}`,
      access: "invoice_view",
    },
  ]

  return (
    <div className=" w-full  h-full py-2 px-4 md:overflow-hidden">
      <div className="sm:flex justify-between w-full ">
        <Breadcrumb
          items={[
            {
              name: "Outgoing",
              link: "/invoice/invoice-outgoing",
            },

            { name: module },
          ]}
        />
        <div className="flex gap-2 justify-end">
          {newfilter && (
            <>
              <FilterButton
                label="Filter"
                handleClick={() => {
                  setFilterOpen(true);
                  setSearchQuery("");
                }}
              />
              {isFilter && (
                <ClearFilterButton label="Clear" handleClick={ClearFilter} />
              )}{" "}
            </>
          )}
          <div className=" flex justify-end items-center gap-3 ">
            <div className=" flex gap-2">
              {/* <Link
                to={`/invoice/invoice-outgoing`}
                state={{
                  currentPage: pageIndex,
                  searchQuery: searchQuery != "" ? searchQuery : "",
                }}
              >
                <BackButton />
              </Link> */}

              <BackButton
                  link={true}
                  hasLink={
                    fromDashboard
                      ? "/dashboard"
                      : module !== "Details"
                      ? `/invoice/invoice-outgoing`
                      : `/invoice/invoice-outgoing`
                  }
                  state={
                    !fromDashboard && module === "Details"
                      ? {
                          currentPage: pageIndex,
                          searchQuery: searchQuery !== "" ? searchQuery : "",
                        }
                      : null
                  }
                />

              {/* <BackButton
                link={true}
                hasLink={
                  module !== "Details"
                    ? `/invoice/invoice-outgoing/view/${invoiceOutgoingViewId}`
                    : `/invoice/invoice-outgoing`
                }
                state={
                  module === "Details"
                    ? {
                      currentPage: pageIndex,
                      searchQuery: searchQuery !== "" ? searchQuery : "",
                    }
                    : null
                }
              /> */}
              {EditAccess && (
                <Link
                  to={`/invoice/invoice-outgoing/edit/${invoiceOutgoingViewId}`}
                  state={{
                    data: data,
                    from: `/invoice/invoice-outgoing/view/${invoiceOutgoingViewId}`,
                  }}
                >
                  <EditButton height="8" />
                </Link>
              )}
            </div>
          </div>
        </div>
      </div>

      <div className="w-full overflow-x-auto whitespace-nowrap scrollbar-hide md:flex gap-x-10 mt-0.5">
        <div className="inline-flex items-center gap-x-1">
          {AllTabs.map((item, i) => {
            const isActive = item?.link === pathname;

            return (
              <React.Fragment key={item?.link || i}>
                {GetAccess(item?.access) && (
                  <Link
                    to={item?.link}
                                                                                                    state={{fromDashboard:fromDashboard}}

                    className={`px-4 py-1 rounded-t-md text-xs 2xl:text-sm font-medium mt-0.5 inline-block
                ${isActive
                        ? "bg-baseColor-primary text-white"
                        : "bg-white text-baseColor-primary border-b-2 border-baseColor-primary"
                      }`}
                  >
                    {item?.label || ""}
                  </Link>
                )}
              </React.Fragment>
            );
          })}
        </div>
        {
          isPaymentHistory && (
            <div className=" flex    flex-wrap rounded-sm gap-6 mt-4 sm:mt-0 text-xs w-[75%] justify-end ">
               <div className=" border border-orange-400 rounded-full flex overflow-hidden h-7  mt-0.5">
                <span className="bg-white text-black px-3 py-1 font-medium flex items-center justify-center text-center ">
                   Payment
                </span>
                <span className="bg-orange-400 text-white px-3 py-1 font-medium flex items-center justify-center text-center">
                  {totalLength || 0}
                </span>
              </div>
               <div className=" border border-blue-400 rounded-full flex overflow-hidden h-7 mt-0.5 ">
                <span className="bg-white text-black px-3 py-1 font-medium flex items-center justify-center text-center2">
                   Total
                </span>
                <span className="bg-blue-400 text-white px-3 py-1 font-medium flex items-center justify-center text-center">
                 <NuAmount value={totalAmount || 0} />
                </span>
              </div>
                <div className=" border border-green-400 rounded-full flex overflow-hidden h-7 mt-0.5">
                <span className="bg-white text-black px-3 py-1 font-medium flex items-center justify-center text-center2">
                   Received
                </span>
                <span className="bg-green-400 text-white px-3 py-1 font-medium flex items-center justify-center text-center">
                 <NuAmount value={paidAmount || 0} />
                </span>
              </div>
                 <div className="border border-yellow-400 rounded-full flex overflow-hidden h-7 mt-0.5">
                <span className="bg-white text-black px-3 py-1 font-medium flex items-center justify-center text-center2">
                   Balance
                </span>
                <span className="bg-yellow-400 text-white px-3 py-1 font-medium flex items-center justify-center text-center">
                 <NuAmount value={balAmount || 0} />
                </span>
              </div>
        
              
            </div>
//             <div className="flex flex-wrap gap-6 mt-4 sm:mt-0 text-xs bg-black w-[75%]  ">
//   {[
//     { label: "Paymt", value: totalLength || 0 },
//     { label: "Total", value: <NuAmount value={totalAmount || 0} /> },
//     { label: "Receiv", value: <NuAmount value={paidAmount || 0} /> },
//     { label: "Bal", value: <NuAmount value={balAmount || 0} /> }
//   ].map((item, i) => (
//     <div
//       key={i}
//       className="border border-baseColor-primary rounded-md flex overflow-hidden"
//     >
//       <span className="bg-white text-black px-4 py-2 font-medium flex items-center justify-center text-center">
//         {item.label}
//       </span>
//       <span className="bg-baseColor-primary text-white px-4 py-2 font-medium flex items-center justify-center text-center">
//         {item.value}
//       </span>
//     </div>
//   ))}
// </div>
          )
        }

      </div>
      <div className=" w-full h-[calc(100vh-160px)]  ">{children}</div>
    </div>
  );
};

export default OutgoingLayout;
